import {useField, useFormikContext} from 'formik'
import React, {useCallback} from 'react'
import {useHook} from '../helpers'
import {TCheckbox, TComponentCheckbox} from './_types'

const Checkbox = React.memo<TCheckbox>((props) => {
    const {
        description,
        resolvedClassNamePrefix,
        article,
        isChecked,
        handleChange,
        is_disabled,
        label,
        hoverLabel,
        buttonLike,
        indeterminate,
    } = props

    const cls = [
        resolvedClassNamePrefix,
        buttonLike ? 'as-button' : '',
        hoverLabel ? 'hover-label-left' : '',
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <label title={label || description || ''} className={cls}>
            <input
                className='form-check-input'
                type='checkbox'
                name={article || undefined}
                checked={isChecked}
                onChange={handleChange}
                disabled={is_disabled}
                aria-label={label || description || article}
                aria-checked={indeterminate ? 'mixed' : isChecked ? 'true' : 'false'}
                ref={(el) => {
                    if (el) el.indeterminate = Boolean(indeterminate)
                }}
            />
            <span className='form-check-label'>{label}</span>
        </label>
    )
})

const ComponentCheckbox: React.FC<TComponentCheckbox> = (props) => {
    const {
        article = 'custom',
        customChecked,
        customHandler,
        indeterminate,
        description,
        label,
        is_disabled,
        hook,
        onChangeSubmit,
        className = '',
        hoverLabel,
        buttonLike,
    } = props

    // два режима: контролируемый (для абзацев) и Formik (для реальных полей)
    const isControlled = typeof customChecked === 'boolean' || typeof customHandler === 'function'

    const {values, setFieldValue, handleSubmit} = useFormikContext<any>()
    const [field] = useField(article) // хук оставляем (минимальные правки)
    const isChecked = isControlled ? Boolean(customChecked) : Boolean(field.value)

    const setValueForHook = useHook({
        article,
        values,
        setFieldValue,
        handleSubmit,
        hook,
        isFilter: onChangeSubmit,
    })
    const isUseBasicSubmit = onChangeSubmit && !hook

    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const resolvedValue = event.target.checked

            if (isControlled) {
                customHandler?.()
                return
            }

            // обычное поле: пишем в Formik
            setFieldValue(article, resolvedValue)
            if (hook) setValueForHook(resolvedValue)
            if (isUseBasicSubmit) handleSubmit()
        },
        [
            isControlled,
            customHandler,
            setFieldValue,
            article,
            hook,
            setValueForHook,
            isUseBasicSubmit,
            handleSubmit,
        ]
    )

    const resolvedClassNamePrefix = `componentCheckbox form-check form-check-sm form-check-custom form-check-solid ${className}`
    const inputArticle = isControlled ? '' : article

    return (
        <Checkbox
            article={inputArticle}
            isChecked={isChecked}
            resolvedClassNamePrefix={resolvedClassNamePrefix}
            description={description}
            is_disabled={is_disabled}
            label={label}
            handleChange={handleChange}
            hoverLabel={hoverLabel}
            buttonLike={buttonLike}
            indeterminate={indeterminate}
        />
    )
}

export default ComponentCheckbox
